const apiAddress = () => {
  // return "http://localhost:4000/api";
  return "/api";
};

export default apiAddress;
